/**
 * Ensures that the given URL starts with a protocol (http:// or https://).
 * If the URL does not start with a protocol, https:// is added.
 *
 * @param {string} url - The URL to be processed.
 * @returns {string} The processed URL, guaranteed to start with a protocol.
 */
export function ensureProtocol(url) {
  if (/^https?:\/\//i.test(url)) {
    return url;
  }
  return `https://${url}`;
}
